import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=70c6c808&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=70c6c808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c6c808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c6c808')) {
      api.createRecord('70c6c808', component.options)
    } else {
      api.reload('70c6c808', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=70c6c808&scoped=true&", function () {
      api.rerender('70c6c808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ga8o4zVvNt5H/JS/comp/DateRange.vue"
export default component.exports